export default __webpack_public_path__ + "static/media/poster.ffc9cfe7.png";